import { createActionGroup, props } from "@ngrx/store";
import { ActionPanelViews } from "@store/doc-viewer/doc-viewer.state";

export const actionPanelActions = createActionGroup({
	source: 'Action Panel',
	events: {
		'View Updated': props<{ selectedView: ActionPanelViews }>(),
	},
});
